"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_admin_1 = require("react-admin");
var styles_1 = require("@mui/material/styles");
var RAStyles_1 = require("./RAStyles");
var react_i18next_1 = require("react-i18next");
var PaginationComponent = function (_a) {
    var _b = _a.rowsPerPageOptions, rowsPerPageOptions = _b === void 0 ? [10, 25, 50, 100] : _b, _c = _a.rowsPerPageLabel, rowsPerPageLabel = _c === void 0 ? "Rows per page" : _c, props = __rest(_a, ["rowsPerPageOptions", "rowsPerPageLabel"]);
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaPaginationTheme },
        react_1.default.createElement(react_admin_1.Pagination, __assign({}, props, { labelRowsPerPage: t(rowsPerPageLabel), rowsPerPageOptions: rowsPerPageOptions, limit: null }))));
};
exports.default = PaginationComponent;
